import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import type { TOC } from '@ember/component/template-only';
export interface BvUnstyledBtnSignature {
    Args: {
        onClick?: (e: PointerEvent) => void;
        testName?: string;
    };
    Blocks: {
        default: [];
    };
    Element: HTMLButtonElement;
}
const BvUnstyledBtnComponent: TOC<BvUnstyledBtnSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <button
    type='button'
    class='u-unstyled-button'
    data-test-bv-btn-name={{@testName}}
    tabindex={{if @onClick 0 -1}}
    ...attributes
    {{on 'click' (optional @onClick)}}
  >
    {{yield}}
  </button>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvUnstyledBtnComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvUnstyledBtn: typeof BvUnstyledBtnComponent;
        'bv-unstyled-btn': typeof BvUnstyledBtnComponent;
    }
}
